module.exports = __webpack_public_path__ + "img/service_gamedev.7e7ad989.jpg";